import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    IconButton,
} from '@mui/material';
import { ListCards } from 'pages/web/settings/subpages/combinations/ListCards';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

interface OvertimeRule {
    overtime_rule_id: number;
    name: string;
}

interface Zone {
    zone_id: number;
    name: string;
}

interface ScheduleDesviationRule {
    schedule_desviation_rule_id: number;
    name: string;
}

interface CombinationRuleRow {
    id: number;
    name: string;
    description?: string;
    overtime_rules?: OvertimeRule[];
    zones?: Zone[];
    schedule_desviation_rules?: ScheduleDesviationRule[];
}

interface InfoCombinationsProps {
    open: boolean;
    setOpenShow: (open: boolean) => void;
    select: CombinationRuleRow;
}

const InfoCombinations = ({ open, setOpenShow, select }: InfoCombinationsProps) => {
    const { t } = useTranslation();
    //console.log(`🚀 ~ file: InfoCombinations.tsx:49 ~ InfoCombinations ~ select:`, select);

    return (
        <>
            <Dialog
                maxWidth="sm"
                fullWidth
                open={open}
                onClose={() => setOpenShow(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t('settings.combinations.dialog.titles.info')}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpenShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <ListCards item={select} />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpenShow(false)}
                        color="error"
                        variant="contained"
                        autoFocus
                    >
                        {t('settings.combinations.dialog.buttons.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export { InfoCombinations };
